import { useStore } from '../state/store'
import { IconCheck, IconClose, IconWarning } from './icons'

export function Toasts() {
  const toasts = useStore((s) => s.toasts)
  const dismiss = useStore((s) => s.dismissToast)
  if (toasts.length === 0) return null
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.kind}`}>
          {t.kind === 'ok' && <IconCheck size={14} />}
          {(t.kind === 'warn' || t.kind === 'error') && <IconWarning size={14} />}
          <span>{t.text}</span>
          <button className="quiet icon-btn" aria-label="Dismiss" onClick={() => dismiss(t.id)}>
            <IconClose size={12} />
          </button>
        </div>
      ))}
    </div>
  )
}
